(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventCategoryType', EventCategoryType);

    EventCategoryType.$inject = ['$resource'];

    function EventCategoryType ($resource) {
        var resourceUrl =  'api/event-category-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
